<template>
  <div class="relative">
    <div
      v-if="showModal"
      class="overflow-y-hidden absolute left-20 top-32"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="flex items-end justify-center min-h-screen px-3 pt-4 ml-32 pb-20 sm:m-5 lg:m-0 text-center sm:block sm:p-0"
      >
        <div
          class="transition-opacity bg-gray-500 bg-opacity-75"
          aria-hidden="true"
        ></div>
        <div
          class="inline-block p-20 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-2xl lg:p-14 lg:ml-60 sm:my-8 sm:align-middle sm:max-w-xl sm:w-full"
        >
          <div>
            <div class="mt-3 flex flex-col items-center justify-center sm:mt-5">
              <div
                class="mb-8 text-2xl font-semibold leading-none tracking-tighter text-neutral-600"
              >
                <img
                  src="../assets/check.png"
                  class="w-20 lg:w-24"
                  alt="sucess"
                />
              </div>
              <slot> </slot>
            </div>
          </div>
          <div class="mt-6 sm:flex">
            <div class="mt-3 sm:ml-24 lg:ml-48 md:ml-56">
              <button @click="closeModal" class="btn btn-primary">Okay</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: ["closeModal", "showModal"],
};
</script>

<style></style>
